module.exports = __webpack_public_path__ + "images/hauts-du-port-fdf0c41dcbbd2869aa3a8a5cdb12ef04.jpg";